import React from 'react';
import closeIcon from '../icons/non-prefilled/16x16/clear.svg';
import IconButton from './IconButton';
import styles from './RightPanel.module.scss';
import StickyHeader from './StickyHeader';

interface RightPanelProps {
  header?: string;
  children?: JSX.Element[] | JSX.Element;
  footer?: JSX.Element[] | JSX.Element;
  close: () => void;
}

const RightPanel = ({ header, children, close, footer }: RightPanelProps) => {
  return (
    <div className={styles.container}>
      <div className={styles.content}>
        <StickyHeader>
          <div className={styles.header}>
            <h3>{header}</h3>
            <IconButton
              size="large"
              onClick={close}
              applyNegativeMargin
              aria-label="Close side panel"
            >
              {closeIcon}
            </IconButton>
          </div>
        </StickyHeader>
        {children}
      </div>
      {footer && <div className={styles.footer}>{footer}</div>}
    </div>
  );
};

export default RightPanel;
